// extracted by mini-css-extract-plugin
module.exports = {"notice-wrapper":"b7635b5199--notice-wrapper--O0e2U","notice":"b7635b5199--notice--HMAj5"};